import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/impressum")({
  head: () => ({
    meta: [
      { title: "Impressum — PIXIWEB" },
      { name: "description", content: "Impressum und Anbieterkennzeichnung gemäß § 5 TMG für PIXIWEB." },
      { name: "robots", content: "noindex,follow" },
      { property: "og:title", content: "Impressum — PIXIWEB" },
      { property: "og:description", content: "Impressum und Anbieterkennzeichnung gemäß § 5 TMG für PIXIWEB — Kontakt, Anschrift und rechtliche Angaben." },
      { property: "og:url", content: "https://pixiweb.de/impressum" },
    ],
    links: [{ rel: "canonical", href: "https://pixiweb.de/impressum" }],
  }),
  component: ImpressumPage,
});

function ImpressumPage() {
  return (
    <div>
      <section className="border-b border-mist bg-ice">
        <div className="container-pixi py-16">
          <p className="eyebrow">Rechtliches</p>
          <h1 className="mt-3 font-display text-5xl font-bold">Impressum</h1>
        </div>
      </section>
      <article className="container-pixi prose-pixi max-w-3xl py-16 text-base leading-relaxed text-navy">
        <section className="space-y-2">
          <h2 className="font-display text-2xl font-semibold">Angaben gemäß § 5 TMG</h2>
          <p>
            Daniel Peters<br />
            Vor dem Esch 7<br />
            32609 Hüllhorst<br />
            Deutschland
          </p>
        </section>

        <section className="mt-10 space-y-2">
          <h2 className="font-display text-2xl font-semibold">Kontakt</h2>
          <p>
            Telefon: <a className="text-electric hover:underline" href="tel:+4917640417218">+49 176 40417218</a><br />
            E-Mail: <a className="text-electric hover:underline" href="mailto:kontakt@pixiweb.de">kontakt@pixiweb.de</a>
          </p>
        </section>

        <section className="mt-10 space-y-2">
          <h2 className="font-display text-2xl font-semibold">Verbraucher­streit­beilegung / Universal­schlichtungs­stelle</h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucher­schlichtungs­stelle teilzunehmen.
          </p>
        </section>

        <section className="mt-10 space-y-2">
          <h2 className="font-display text-2xl font-semibold">
            Zentrale Kontaktstelle nach dem Digital Services Act – DSA (Verordnung (EU) 2022/2065)
          </h2>
          <p>
            Unsere zentrale Kontaktstelle für Nutzer und Behörden nach Art. 11, 12 DSA erreichen
            Sie wie folgt:
          </p>
          <p>
            E-Mail: <a className="text-electric hover:underline" href="mailto:kontakt@pixiweb.de">kontakt@pixiweb.de</a>
          </p>
          <p>Die für den Kontakt zur Verfügung stehenden Sprachen sind: Deutsch, Englisch.</p>
        </section>

        <p className="mt-10 text-sm text-slate">
          Quelle: Erstellt mit dem Impressums-Generator von eRecht24.
        </p>
      </article>
    </div>
  );
}
